module.exports = __webpack_public_path__ + "media/images/emblems/Geroldswil-blazon-7636f32513cd17710baa924b78e0f8d8.svg";